<div
  class="date-picker-input"
  [attr.data-size]="size"
  [attr.data-variant]="variant"
  [attr.data-disabled]="disabled"
  [attr.data-required]="required"
  [attr.data-error]="error"
  [attr.data-readonly]="readonly"
  [attr.data-has-value]="hasValue"
  [attr.data-full-width]="fullWidth"
>
  <!-- Label -->
  <label *ngIf="label" class="date-picker-input-label" [for]="computedId">
    {{ label }}
    <span *ngIf="required" class="required-indicator" aria-hidden="true">
      *
    </span>
  </label>

  <!-- Input Container -->
  <div class="date-picker-input-container">
    <!-- Calendar Icon -->
    <div class="date-picker-input-icon" aria-hidden="true">
      <umss-icon name="phosphorCalendar" [size]="iconSize" />
    </div>

    <!-- Input Field -->
    <input
      [id]="computedId"
      [type]="inputType"
      class="date-picker-input-field"
      [value]="displayValue"
      [placeholder]="placeholder"
      [disabled]="disabled"
      [readonly]="readonly"
      [required]="required"
      [min]="min"
      [max]="max"
      [attr.aria-label]="label || placeholder"
      [attr.aria-describedby]="error ? computedId + '-error' : null"
      (input)="onInputChange($event)"
      (focus)="onInputFocus($event)"
      (blur)="onInputBlur($event)"
    />

    <!-- Clear Button -->
    <button
      *ngIf="hasValue && ((!disabled && !readonly) || clearable)"
      type="button"
      class="date-picker-input-clear"
      aria-label="Clear date"
      (click)="clear()"
    >
      <umss-icon name="phosphorX" size="12px" />
    </button>
  </div>

  <!-- Error Message -->
  <div
    *ngIf="error"
    class="date-picker-input-error"
    [id]="computedId + '-error'"
  >
    <umss-icon name="phosphorWarning" size="12px" aria-hidden="true" />
    <span>{{ errorMessage ?? 'Please enter a valid date' }}</span>
  </div>
</div>
